import { Vector3 as n } from "three";
import { getMatrix as i } from "../three/index9.js";
function m(r, o) {
  const t = Array.isArray(r) ? new n().fromArray(r) : r.clone(), a = i(o);
  return t.applyMatrix4(a.invert()), Array.isArray(r) ? t.toArray() : t;
}
export {
  m as applyInverseTransform
};
//# sourceMappingURL=index.js.map
